import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'
import { arrayToString, parseJwt } from '_utils/function'
import { setUserToken as setLocalUserToken, setUserInfo, setSocialToken } from '_utils/localData'
import authApi from '_api/auth'
import axiosClient from '_api/axiosClient'

export const useGuestCreateAccount = () => {
  const { addToast } = useToasts()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const registerWithPIN = async ({ guestFormData, pin }) => {
    const { name, email, mobile } = guestFormData || {}

    if (!name?.trim() || !email?.trim() || !mobile?.trim()) {
      addToast('Guest information is missing', { appearance: 'error', autoDismiss: true })
      return null
    }

    if (!pin || pin.some((item) => item === undefined) || pin[0] === undefined) {
      return null
    }

    try {
      setIsSubmitting(true)
      const password = arrayToString(pin)

      const res = await authApi.register({
        name: name.trim(),
        email: email.toLowerCase().trim(),
        phone: mobile.trim(),
        password,
      })

      const token = res?.msgResp?.token
      if (token) {
        setLocalUserToken(token)
        setUserInfo(parseJwt(token))
        axiosClient.defaults.headers.common.Authorization = `Bearer ${token}`
        return token
      }

      addToast('Registration failed', { appearance: 'error', autoDismiss: true })
      return null
    } catch (error) {
      addToast(error?.msgResp || 'Registration failed', { appearance: 'error', autoDismiss: true })
      return null
    } finally {
      setIsSubmitting(false)
    }
  }

  const registerWithGoogle = async ({ googleResponse, guestFormData }) => {
    try {
      const accessToken = googleResponse?.accessToken
      const phone = guestFormData?.mobile?.trim()
      const email = googleResponse?.Iy?.Fz?.trim()
      const name = googleResponse?.Iy?.dh?.trim()
      const linkedGoogleAccount = googleResponse?.Fa

      if (!accessToken || !phone || !email || !name || !linkedGoogleAccount) {
        addToast('Google sign up failed', { appearance: 'error', autoDismiss: true })
        return null
      }

      setIsSubmitting(true)

      const res = await authApi.register({
        email,
        name,
        phone,
        linkedGoogleAccount,
        accessToken,
      })

      const token = res?.msgResp?.token
      if (token) {
        setLocalUserToken(token)
        setUserInfo(parseJwt(token))
        setSocialToken(accessToken)
        axiosClient.defaults.headers.common.Authorization = `Bearer ${token}`
        return token
      }

      addToast('Google sign up failed', { appearance: 'error', autoDismiss: true })
      return null
    } catch (error) {
      addToast(error?.msgResp || 'Google sign up failed', { appearance: 'error', autoDismiss: true })
      return null
    } finally {
      setIsSubmitting(false)
    }
  }

  return {
    registerWithPIN,
    registerWithGoogle,
    isSubmitting,
  }
}
